/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingsEmailAppEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const HelpCenterSettingsEmailAppEntryPoint: EntryPoint<
	HelpCenterSettingsEmailAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingsEmailAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-settings-email-app" */ './HelpCenterSettingsEmail.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
